import { render } from "./NewCommunityCard.vue?vue&type=template&id=833a3e4a&ts=true"
import script from "./NewCommunityCard.vue?vue&type=script&lang=ts"
export * from "./NewCommunityCard.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__